import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';
import { type ReactNode, useId } from 'react';

export type FlightCheckDoneIconProps = SvgIconProps;

export function FlightCheckDoneIcon(props: FlightCheckDoneIconProps): ReactNode {
  const pageId = useId();
  const markId = useId();
  return (
    <SvgIcon viewBox="0 0 16 16" {...props}>
      <g clipPath={`url(#${pageId})`}>
        <path
          d="M10.8538 3.36577L7.35375 0.135C7.30728 0.0921535 7.25212 0.0581778 7.19143 0.0350141C7.13073 0.0118504 7.06568 -4.75319e-05 7 1.42707e-07H1C0.734784 1.42707e-07 0.48043 0.0972526 0.292893 0.270363C0.105357 0.443474 0 0.678262 0 0.923077V11.0769C0 11.3217 0.105357 11.5565 0.292893 11.7296C0.48043 11.9027 0.734784 12 1 12H10C10.2652 12 10.5196 11.9027 10.7071 11.7296C10.8946 11.5565 11 11.3217 11 11.0769V3.69231C11.0001 3.63168 10.9872 3.57164 10.9621 3.51561C10.937 3.45958 10.9002 3.40866 10.8538 3.36577ZM7.5 1.57558L9.29313 3.23077H7.5V1.57558ZM10 11.0769H1V0.923077H6.5V3.69231C6.5 3.81472 6.55268 3.93211 6.64645 4.01866C6.74021 4.10522 6.86739 4.15385 7 4.15385H10V11.0769Z"
          fill="currentColor"
        />
        <rect x="6.5" y="6.5" width="9" height="9" rx="4.5" fill="currentColor" />
        <rect
          x="6.5"
          y="6.5"
          width="9"
          height="9"
          rx="4.5"
          stroke="currentColor"
          fill="currentColor"
        />
        <g clipPath={`url(#${markId})`}>
          <path
            d="M13.5005 9.12891C13.6099 9.12897 13.7151 9.17171 13.7925 9.24902C13.8699 9.32648 13.9136 9.43245 13.9136 9.54199C13.9135 9.65138 13.8698 9.75663 13.7925 9.83398L13.7212 9.9043L13.7202 9.90332L10.4585 13.166C10.4202 13.2044 10.3748 13.235 10.3247 13.2559C10.2746 13.2767 10.2208 13.2881 10.1665 13.2881C10.1122 13.2881 10.0584 13.2767 10.0083 13.2559C9.95816 13.235 9.91283 13.2045 9.87451 13.166L8.41553 11.708C8.37735 11.6698 8.34736 11.6241 8.32666 11.5742C8.3059 11.5241 8.29541 11.4703 8.29541 11.416C8.29541 11.3618 8.30591 11.3079 8.32666 11.2578C8.34737 11.2079 8.37735 11.1623 8.41553 11.124C8.45388 11.0857 8.50018 11.0549 8.55029 11.0342C8.60031 11.0135 8.65438 11.0029 8.7085 11.0029C8.76243 11.003 8.81587 11.0136 8.86572 11.0342C8.91584 11.0549 8.96213 11.0857 9.00049 11.124L10.1665 12.29L13.2085 9.24902C13.2859 9.17181 13.3911 9.12891 13.5005 9.12891Z"
            fill="#FFFFFF"
            stroke="#FFFFFF"
            strokeWidth="0.2"
          />
        </g>
      </g>
      <defs>
        <clipPath id={pageId}>
          <rect width="16" height="16" fill="#FFFFFF" />
        </clipPath>
        <clipPath id={markId}>
          <rect
            width="6.66667"
            height="6.66667"
            fill="#FFFFFF"
            transform="translate(7.6665 7.6665)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
